// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17V8F","left":"styles_left__ZcACI","desktopActions":"styles_desktopActions__1qdmp","title":"styles_title__1yMx8"};